"use client"

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogTitle,
} from "../ui/dialog"

type ProfileNavLockDialogProps = {
    open: boolean
    onOpenChange: (open: boolean) => void
}

function ProfileNavLockDialog({ open, onOpenChange }: ProfileNavLockDialogProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md">
                <DialogTitle>Complete your Profile to unlock ReliefHub</DialogTitle>
                <DialogDescription>
                    Complete the yellow required fields and save your Profile to access ReliefHub navigation and serve information.
                </DialogDescription>
            </DialogContent>
        </Dialog>
    )
}

export default ProfileNavLockDialog
